<template>
  <div class="navbar-header d-xl-block d-none">
    <ul
      class="nav navbar-nav"
      style="justify-content: space-between;"
    >
      <li
        v-if="showArtpmLogo"
        class="nav-item"
        style="display: flex; align-items: center;"
      >
        <b-link
          class="navbar-brand"
          href="https://artpm.pl/"
          target="_blank"
        >
          <span class="brand-logo">
            <img
              src="@/assets/images/logo/artpm.png"
              alt="logo"
            >
          </span>
        </b-link>
      </li>
      <li
        class="nav-item"
        style="display: flex; align-items: center;"
      >
        <b-link
          class="navbar-brand"
          to="/"
        >
          <span class="brand-logo">
            <img
              :src="appLogoImage"
              alt="logo"
            >
          </span>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    const showArtpmLogo = process.env.VUE_APP_SHOW_ARTPM_LOGO === 'true'
    return {
      appName,
      appLogoImage,
      showArtpmLogo,
    }
  },
}
</script>

<style>

</style>
